import { ChangeEvent, KeyboardEventHandler } from 'react';
import { HelperText, Input } from './styles';

interface PhoneNumberInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  error?: boolean;
  helperText?: string;
  ariaLabel?: string;
  onKeyDown?: KeyboardEventHandler<HTMLInputElement>;
}

export const PhoneNumberInput = ({
  value,
  onChange,
  placeholder,
  disabled = false,
  required = false,
  error = false,
  helperText,
  ariaLabel,
  onKeyDown,
}: PhoneNumberInputProps) => (
  <div>
    <Input
      type="tel"
      inputMode="tel"
      autoComplete="tel"
      value={value || ''}
      onChange={(event: ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}
      onKeyDown={onKeyDown}
      placeholder={placeholder}
      disabled={disabled}
      required={required}
      aria-label={ariaLabel}
      aria-invalid={error}
    />
    {helperText && <HelperText error={error}>{helperText}</HelperText>}
  </div>
);